
import { Component, Prop, Vue } from "vue-property-decorator";

import PICTURE_1 from "@/components/V2/WidgetSkilledWorkerVisa/line_1.png";
import PICTURE_2 from "@/components/V2/WidgetSkilledWorkerVisa/line_2.png";
import { SMUser } from "@/store";

const CLASS = "package";

@Component
export default class PriceItem extends Vue {
  @Prop({ type: Object }) readonly service;
  @Prop({ type: Boolean, default: false }) readonly dark;
  @Prop({ type: Boolean, default: false }) readonly loading;

  PICTURE_1 = PICTURE_1;
  PICTURE_2 = PICTURE_2;

  get classes() {
    return {
      [`${CLASS}_dark`]: this.dark,
      [`${CLASS}_disabled`]: this.loading,
      [`${CLASS}_image-bcg`]: this.service.background,
    };
  }

  get buttonProps() {
    return {
      outline: !this.dark,
    };
  }

  get label() {
    return this.service.button.toString();
  }

  submitRequest(id) {
    if (!id) return;

    this.$emit("submit", id);
  }

  get hasPrepaidCosSW() {
    return this.service.title === "CoS + Skilled Worker visa" && !!SMUser.prepaidCosSW;
  }
}
